import { defineComponent as _defineComponent } from 'vue'
import EditRegisteredProduct from './edit_registered_product.vue'

    import { ref, computed, watch, inject, useTemplateRef, onMounted, nextTick } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import { computedAsync } from '@vueuse/core'
    import { create_or_edit_registered_part, delete_registered_part, list_invoices, list_registered_parts } from '../../module/invoices/module';
    import { Size } from '../../components/basic_button/size';
    import { vendors, vendor_id_to_name } from '../../module/common/module';

    interface RegisteredItemNameVendor {
        id: number,
        registered_item_name_id: number,
        part_name: string,
        vendor_id: number,
        created_at: Date,
        updated_at: Date
    }

    interface RegisteredProduct {
        id: number,
        name: string,
        created_at: Date|null,
        updated_at: Date|null,
        RegisteredItemNameVendors: RegisteredItemNameVendor[]
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'registered_products',
  setup(__props, { expose: __expose }) {
  __expose();

    const router = useRouter()

    const update_list_counter = ref(1)
    const page_number = ref(1)
    const page_size = ref(25)
    const search_text = ref("")

    const registered_products = computedAsync(
        async () => {
            let loc_page_number = page_number.value + update_list_counter.value - update_list_counter.value
            let loc_page_size = page_size.value
            let loc_search_text = search_text.value
            return await list_registered_parts(loc_search_text, loc_page_size, loc_page_number)
        },
        [], /* initial state */
        
    )

    const print_parts = function(registered_product: RegisteredProduct, vendor_id: number) {

        return registered_product.RegisteredItemNameVendors
            .filter(function(registered_item: RegisteredItemNameVendor) {
                return registered_item.vendor_id == vendor_id
            })
            .map(function(registered_item: RegisteredItemNameVendor) {
                return registered_item.part_name
            })
            .join(", ")
    }

    const vendor_ids_from_registered_product = function(registered_product: RegisteredProduct) {
        const loc_vendor_ids = registered_product.RegisteredItemNameVendors
            .map(function(registered_item: RegisteredItemNameVendor) {
                return registered_item.vendor_id
            })

        return [...new Set(loc_vendor_ids)]
    }

    function registered_product_to_create_or_edit_request(registered_product: RegisteredProduct): object {
        const convert_vendor_to_parts = function (registered_product: RegisteredProduct, vendor_id: number) {
            return registered_product.RegisteredItemNameVendors
                .filter(function(registered_item: RegisteredItemNameVendor) {
                    return registered_item.vendor_id == vendor_id
                })
                .map(function(registered_item: RegisteredItemNameVendor) {
                    return registered_item.part_name
                })
        }

        const save_part_request = {
            "registered_part_name": registered_product.name,
            "vendor_parts": [
                {
                    "vendor_id": 1,
                    "part_names": convert_vendor_to_parts(registered_product, 1)
                },
                {
                    "vendor_id": 2,
                    "part_names": convert_vendor_to_parts(registered_product, 2)
                },
                {
                    "vendor_id": 3,
                    "part_names": convert_vendor_to_parts(registered_product, 3)
                },
                {
                    "vendor_id": 4,
                    "part_names": convert_vendor_to_parts(registered_product, 4)
                },
                {
                    "vendor_id": 5,
                    "part_names": convert_vendor_to_parts(registered_product, 5)
                },
                {
                    "vendor_id": 6,
                    "part_names": convert_vendor_to_parts(registered_product, 6)
                },
                {
                    "vendor_id": 7,
                    "part_names": convert_vendor_to_parts(registered_product, 7)
                },
                {
                    "vendor_id": 8,
                    "part_names": convert_vendor_to_parts(registered_product, 8)
                },
                {
                    "vendor_id": 9,
                    "part_names": convert_vendor_to_parts(registered_product, 9)
                },
                {
                    "vendor_id": 10,
                    "part_names": convert_vendor_to_parts(registered_product, 10)
                }
                
            ]
        }

        return save_part_request
    }


    let selected_registered_product = ref({
        id: -1,
        name: "",
        created_at: null,
        updated_at: null,
        RegisteredItemNameVendors: []
    } as RegisteredProduct)

    let opened = ref(false)
    
    const cancel_edit_part = function() {
        opened.value = false
        selected_registered_product.value = {
            id: -1,
            name: "",
            created_at: null,
            updated_at: null,
            RegisteredItemNameVendors: []
        } as RegisteredProduct
    }

    const edit_part = function(registered_product: RegisteredProduct) {
        opened.value = true
        selected_registered_product.value = registered_product
    }

    const new_part = function() {
        opened.value = true
        selected_registered_product.value = {
            id: -1,
            name: "",
            created_at: null,
            updated_at: null,
            RegisteredItemNameVendors: []
        } as RegisteredProduct
    }

    const save_part = async function(registered_product: RegisteredProduct) {
        opened.value = false
        const save_part_request = registered_product_to_create_or_edit_request(registered_product)
        await create_or_edit_registered_part(save_part_request.registered_part_name, save_part_request.vendor_parts)

        update_list_counter.value++
    }

    const delete_part = async function(registered_product: RegisteredProduct) {
        await delete_registered_part(registered_product.name)

        update_list_counter.value++
    }


const __returned__ = { router, update_list_counter, page_number, page_size, search_text, registered_products, print_parts, vendor_ids_from_registered_product, registered_product_to_create_or_edit_request, get selected_registered_product() { return selected_registered_product }, set selected_registered_product(v) { selected_registered_product = v }, get opened() { return opened }, set opened(v) { opened = v }, cancel_edit_part, edit_part, new_part, save_part, delete_part, EditRegisteredProduct, get Size() { return Size }, get vendor_id_to_name() { return vendor_id_to_name } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})